import { render, staticRenderFns } from "./batchPriority.vue?vue&type=template&id=1cf9b43d&scoped=true"
import script from "./batchPriority.vue?vue&type=script&lang=js"
export * from "./batchPriority.vue?vue&type=script&lang=js"
import style0 from "./batchPriority.vue?vue&type=style&index=0&id=1cf9b43d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf9b43d",
  null
  
)

export default component.exports